import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, withRouter, Switch } from 'react-router-dom'
import Helmet from 'react-helmet';
import capitalize from 'lodash/capitalize';
import Navbar from 'components/merchant/navbar';
import Notification from 'components/shared/notification'
import Dashboard from 'containers/merchant/dashboard'
import Messages from 'containers/merchant/messages'
import Profile from 'forms/merchant/profile'
import Venues from './venues'

const Merchant = ({ match, notification: { type, message } }) => {
  const format = location.pathname.replace(/\/merchant\//, '');
  const header = location.pathname === '/merchant' ? 'Dashboard' : format;
  return (
    <Fragment>
      {type && <Notification type={type} message={message} />}
      <Helmet>
        <title>{capitalize(header.replace(/\//g, ' > '))} | Merchant</title>
      </Helmet>
      <Navbar />
      <div className="merchant min-h-vh-msg">
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            component={Dashboard} />
          <Route
            path={`${match.path}/messages/:filter?`}
            component={Messages} />
          <Route
            path={`${match.path}/account`}
            component={Profile} />
          <Route
            path={`${match.path}/venues`}
            component={Venues} />
        </Switch>
      </div>
    </Fragment>
  )
}

Merchant.propTypes = {
  match: PropTypes.object.isRequired,
  notification: PropTypes.object,
}

const mapStateToProps = ({ notification }) => ({
  notification,
})

export default connect(mapStateToProps)(withRouter(Merchant))
